import React from "react";
import PhonePeAppForAllSection from "./PhonePeAppForAllSection/PhonePeAppForAllSection";
import PhonePeAppForMerchantSection from "./PhonePeAppForMerchantSection/PhonePeAppForMerchantSection";
import SEO from "../../components/seo";

import Layout from "../../components/Layout/Layout";
const AppDownloadPage = () => (
    <Layout>
        <SEO
            title="PhonePe - download the app!"
            description=" Download the PhonePe app to make super fast money transfers and bill payments! Download the app easily using these links. Accepting payments with PhonePe? Use this link to download the PhonePe for Business App!"
            url="https://www.phonepe.com/app-download/"
        />
        <PhonePeAppForAllSection />
        <PhonePeAppForMerchantSection />
    </Layout>
);

export default AppDownloadPage;
